import type { TabularRasaAccessorFnProps, TabularRasaAccessorFn } from "@bracket/ui/types";
import { Text, } from "@bracket/ui";
import { raise, } from "@bracket/errant";

export const IconAccessor = <K extends keyof T, T extends object>({ value, }: TabularRasaAccessorFnProps<K, T, "TextNode">) => {
	try {
		if(typeof value !== "number") {
			console.warn("CurrencyAccessor - value should	be a number", value);
			value = typeof value === "string" ? parseFloat(value) as T[K] : raise("CurrencyAccessor - value must be a number");
			if(typeof value !== "number" || isNaN(value)) {
				throw new Error(`CurrencyAccessor - value must be a number`);
			}
		}
		return <Text>{value.toLocaleString("en-US", { style: "currency", currency: "USD", })}</Text>;
	}
	catch(error) {
		console.error(error);
		return <Text> - </Text>;
	}
};
